import {ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {toBoolean} from '../core/convert';

@Component({
  selector: 'jd-form-label',
  template: `
    <label [attr.for]="jdFor" [class.ant-form-item-required]="jdRequired">
      <ng-content></ng-content>
    </label>
  `,
  styles: [`
    .ant-form-item-label {
      text-overflow:ellipsis;
    }
  `],
  host: {
    '[class.ant-form-item-label]': 'true',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class JdFormLabelComponent implements OnInit {
  @HostBinding('style.width') _hostWidth = '100%';
  @Input() jdFor: string;
  private _required = false;

  @Input()
  set jdRequired(value: boolean) {
    this._required = toBoolean(value);
  }

  get jdRequired(): boolean {
    return this._required;
  }

  ngOnInit() {
  }

}
